import React, { Fragment, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
// Headless UI, for more info and examples you can check out https://github.com/tailwindlabs/headlessui
import { Menu, Transition } from '@headlessui/react';
import { ai4curbWhiteIcon, ai4curbTransparentIcon } from "../../assets";
import { signOut } from 'firebase/auth';
import { auth } from '../../config/firebase';

export default function DashboardHeader() {

  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const navigate = useNavigate();

  // Handle sign out
  const handleSignOut = async () => {
    try {
      await signOut(auth);
      localStorage.removeItem('isLoggedIn');
      navigate('/signin'); // Redirect to sign-in page after logout
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  // Menu items array to populate both desktop and mobile links
  const menuItems = [
    { name: 'Home', url: '/home' },
    { name: 'Inventory Management', url: '/inventory' },
    { name: 'Curbside Asset Management', url: '/asset' },
    { name: 'Street Surface Infrastructure', url: '/streetsurface' },
  ];

  return (
    <>
      {/* Page Container */}
      <div className="relative bg-gray-900 dark:bg-gray-900 dark:text-gray-100">
        {/* Page Header */}

        <header className="z-10 flex flex-none items-center bg-gray-800 shadow-sm py-2">

          {/* Main Header Content */}
          <div className="container mx-auto flex items-center justify-between px-4 text-center lg:px-8 xl:max-w-7xl">
            
            {/* Logo */}
            <Link to="/" className="inline-flex items-center space-x-2 text-lg font-bold tracking-wide text-white">
              <img src={ai4curbWhiteIcon} alt="Ai4Curb" className="w-[70px] h-auto" />
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden space-x-10 lg:flex">
              {menuItems.map((item) => (
                <Link key={item.name} to={item.url} className="text-sm font-semibold text-white hover:text-green-300">
                  {item.name}
                </Link>
              ))}
            </nav>

            {/* Dropdown for Account */}
            <Menu as="div" className="relative z-20">
              <Menu.Button className="inline-flex items-center space-x-2 rounded-lg px-3 py-2 text-sm font-semibold text-white bg-gray-700 hover:bg-gray-600">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  stroke="currentColor"
                  className="h-5 w-5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5.121 17.804A3.992 3.992 0 018 16h8a3.992 3.992 0 012.879 1.804M15 11a3 3 0 11-6 0 3 3 0 016 0zm4 10H5a2 2 0 01-2-2v-1a10 10 0 0110-10h0a10 10 0 0110 10v1a2 2 0 01-2 2z"
                  />
                </svg>
                <span>Account</span>
              </Menu.Button>

              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="opacity-0 scale-90"
                enterTo="opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-90"
              >
                <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-lg shadow-xl focus:outline-none">
                  <div className="divide-y divide-gray-100 rounded-lg bg-white dark:bg-gray-800">
                    <div className="p-2.5">
                      <Menu.Item>
                        {({ active }) => (
                          <button
                            onClick={handleSignOut}
                            className={`flex items-center px-2.5 py-2 text-sm font-medium rounded-lg w-full text-left ${
                              active ? 'bg-gray-200 dark:bg-gray-700' : ''
                            }`}
                          >
                            Sign out
                          </button>
                        )}
                      </Menu.Item>
                    </div>
                  </div>
                </Menu.Items>
              </Transition>
            </Menu>
            

            <div className="flex justify-between py-1">

              {/* Left Section */}
              <div className="dark flex items-center space-x-2 lg:space-x-6">
                {/* Logo */}
                {/* <Link to="/#" className="group inline-flex items-center space-x-2 text-lg font-bold tracking-wide text-gray-900 hover:text-gray-600 dark:text-gray-100 dark:hover:text-gray-300">
                  <img src={ai4curbWhiteIcon} alt="Ai4Curb" className="w-[70px] h-auto" />
                </Link> */}
                {/* END Logo */}

                {/* Desktop Navigation */}
                {/* <nav className="hidden items-center space-x-2 lg:flex">
                  {
                    menuItems.map((item) => (
                      <Link key={item.name} to={item.url}>
                        <button type="button" className="group flex items-center space-x-2 rounded-lg border border-transparent px-3 py-2 text-sm font-semibold text-white hover:bg-primary-50 hover:text-primary-600 active:border-primary-100 dark:text-gray-100 dark:hover:bg-gray-700 dark:hover:text-white dark:active:border-gray-600">
                          {item.name}
                        </button>
                      </Link>
                    ))
                  }
                </nav> */}
                {/* END Desktop Navigation */}
              </div>
              {/* END Left Section */}

              {/* Right Section */}
              {/* <div className="flex items-center space-x-2"> */}
              <div className="flex items-center justify-center gap-2">

                {/* Toggle Mobile Navigation */}
                <div className="dark lg:hidden">
                  <button onClick={() => setMobileNavOpen(!mobileNavOpen)}
                    type="button" className="inline-flex items-center justify-center space-x-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-semibold leading-5 text-gray-800 hover:border-gray-300 hover:text-gray-900 hover:shadow-sm focus:ring focus:ring-gray-300 focus:ring-opacity-25 active:border-gray-200 active:shadow-none dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300 dark:hover:border-gray-600 dark:hover:text-gray-200 dark:focus:ring-gray-600 dark:focus:ring-opacity-40 dark:active:border-gray-700">
                    <svg fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" className="hi-solid hi-menu inline-block size-5">
                      <path fillRule="evenodd" clipRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" />
                    </svg>
                  </button>
                </div>
                {/* END Toggle Mobile Navigation */}
              </div>
              {/* END Right Section */}
            </div>

            {/* Mobile Navigation */}
            <Transition
              as={Fragment}
              show={mobileNavOpen}
              enter="transition ease-out duration-200"
              enterFrom="opacity-050 translate-x-full"
              enterTo="opacity-100 translate-x-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-x-0"
              leaveTo="opacity-50 translate-x-full"
            >
              <nav
                id="tkMobileNav"
                className="fixed bottom-0 right-0 top-0 z-50 w-72 overflow-auto bg-white/95 shadow-lg lg:hidden dark:bg-gray-800/95"
                tabIndex={-1}
                aria-labelledby="tkMobileNavLabel"
                aria-modal="true"
                role="dialog"
              >
                <div className="flex items-center justify-between p-6">

                  <Link to="/#" className="group inline-flex items-center space-x-2 text-lg font-bold tracking-wide text-gray-900 hover:text-gray-600 dark:text-gray-100 dark:hover:text-gray-300" >
                    <img src={ai4curbTransparentIcon} alt="Ai4Curb" className="hi-mini hi-cube-transparent inline-block size-12 text-primary-600 transition group-hover:scale-110 dark:text-primary-400" />
                  </Link>

                  {/* Close Button for Mobile Navigation */}
                  <button
                    onClick={() => setMobileNavOpen(false)}
                    type="button"
                    className="inline-flex items-center justify-center space-x-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-semibold leading-5 text-gray-800 hover:border-gray-300 hover:text-gray-900 hover:shadow-sm focus:ring focus:ring-gray-300 focus:ring-opacity-25 active:border-gray-200 active:shadow-none dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300 dark:hover:border-gray-600 dark:hover:text-gray-200 dark:focus:ring-gray-600 dark:focus:ring-opacity-40 dark:active:border-gray-700"
                  >
                    <svg
                      className="hi-mini hi-x-mark -mx-0.5 inline-block size-5"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true">
                      <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
                    </svg>
                  </button>
                  {/* END Close Mobile Navigation */}
                </div>

                {/** Divider */}
                <div className="h-px bg-gray-200/75 dark:bg-gray-700/75" />

                <nav className="flex flex-col gap-2 px-6 py-5">
                  {menuItems.map((item) => (
                    <Link
                      key={item.name}
                      to={item.url}
                      className="py-1 text-sm font-semibold text-gray-900 hover:text-primary-600 dark:text-gray-100 dark:hover:text-primary-400"
                    >
                      <span>{item.name}</span>
                    </Link>
                  ))}
                </nav>
              </nav>
            </Transition>
            {/* END Mobile Navigation */}
          </div>

          {/* Mobile Navigation Backdrop */}
          <Transition
            as={Fragment}
            show={mobileNavOpen}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div
              onClick={() => setMobileNavOpen(false)}
              className="fixed inset-0 z-40 bg-gray-900 bg-opacity-20 backdrop-blur-sm will-change-auto lg:hidden dark:bg-opacity-80"
            />
          </Transition>
          {/* END Mobile Navigation Backdrop */}

        </header>
        {/* END Page Header */}
        
      </div>
      {/* END Page Container */}
    </>
  );
}
